import {
  ActionIcon,
  Box,
  Button,
  createStyles,
  Divider,
  Flex,
  Grid,
  Group,
  Text,
  TextInput,
} from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { inviteContractor } from "../../../services";
import { useState } from "react";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
    minHeight: "100vh",
  },
}));

const AddContractor = () => {
  const { profile } = useSelector((state) => state?.profile);
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        email,
      };
      const res = await inviteContractor(payload);
      res && handleBack();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/home/staff");
  };

  return (
    <Box className={classes.content}>
      <AppNavbar title="Staff" profile={profile} />

      <Flex
        align="center"
        gap={5}
        m={10}
        onClick={handleBack}
        style={{ cursor: "pointer", width: "fit-content" }}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Box p={20}>
        <Box mt="2rem">
          <TextInput
            label="Email"
            placeholder="Enter Email"
            type='email'
            radius="md"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Divider my={10} />
          <Box pt={20}>
            <Group grow>
              <Button
                fullWidth
                color="gray"
                variant="light"
                c={"#000"}
                style={{ width: "50%" }}
                onClick={handleBack}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                c={"#000"}
                color="yellow"
                style={{ width: "50%" }}
                onClick={handleSubmit}
                loading={loading}
                disabled={!email || loading}
              >
                invite
              </Button>
            </Group>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AddContractor;
